<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                预防温室效应
            </div>
            <div class="content">
                <div>
                    <p>少用含氟利昂的空調，尽量乘公共汽车</p>
                    <p>减少CO2的排放，少使用可以生成二氧化碳的物品</p>
                    <p></p>

                    <p>多植树，退耕还林</p>
                </div>

                <div class="image-content">
                    <img class="img1" src="../../assets/images/dashu2.jpg" />
                    <img class="img2" src="../../assets/images/dashu1.jpg" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "GreenhouseSoluteIndexView"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
                .image-content {
                    margin-top: 10%;
                    margin-left: 5%;
                    img {
                        width: 45%;
                        height: 320px;
                        &.img2 {
                            float: right;
                        }
                    }
                    width: 95%;
                }
            }
            p {
                text-align: center;
                line-height: 26px;
            }
        }
    }
</style>